import { applyAgGridLicense } from "./agGridLicense.ts";

applyAgGridLicense();
